import { Course } from '../models/course.model';
import { BackendHttpService } from './backendHttpService';

export class CoursesService extends BackendHttpService {
  constructor() {
    super('course');
  }

  async getDataByPersonID(personId: number): Promise<Course[]> {
    return this.getCourseListByPersonId(personId);
  }

  async addData(data: Course): Promise<Course> {
    return this.addCourseItem(data);
  }

  async updateData(data: Course): Promise<Course> {
    return this.updateCourseItem(data);
  }

  async deleteData(data: Course): Promise<void> {
    return this.deleteCourseItem(data);
  }

  async getCourseListByPersonId(personId: number): Promise<Course[]> {
    try {
      const courses = await this.get<Course[]>(`/byUserId/${personId}`);
      return courses.map(course => ({
        ...course,
        date: new Date(course.date)
      }));
    } catch (error) {
      console.error(`Error getting course list for person ${personId}:`, error);
      throw error;
    }
  }

  async addCourseItem(course: Course): Promise<Course> {
    try {
      return await this.post<Course, Course>(course);
    } catch (error) {
      console.error('Error adding course item:', error);
      throw error;
    }
  }

  async updateCourseItem(course: Course): Promise<Course> {
    try {
      return await this.put<Course, Course>(course, course.id.toString());
    } catch (error) {
      console.error('Error updating course item:', error);
      throw error;
    }
  }

  async deleteCourseItem(course: Course): Promise<void> {
    try {
      await this.delete(course.id.toString());
    } catch (error) {
      console.error('Error deleting course item:', error);
      throw error;
    }
  }
} 
